<template>
  <v-row
    class="data-iterator-footer my-3 mx-4"
    align="center"
    justify="center"   
    v-if="!(numberOfPages === 1 && itemsPerPage === possibleItemsPerPage[listStyle][0])"
  >
    <v-pagination
      v-model="pageProp"
      :length="numberOfPages ? numberOfPages : 1"
      :total-visible="9"
      next-icon="$paginationright"
      prev-icon="$paginationleft"
      elevation="0"
      outlined
    >

    </v-pagination>

    <v-spacer v-if="!$vuetify.breakpoint.mobile"></v-spacer>
    <div class="data-iterator-page-number" v-if="!$vuetify.breakpoint.mobile">
      <span>{{ perPageLabel || $t('table.footer.record') }}</span>
      <v-btn
        v-for="(item, index) in possibleItemsPerPage[listStyle]"
        :key="index"
        elevation="0"
        @click="updateItemsPerPage(possibleItemsPerPage[listStyle][index])"
        :class="
          pageNumberIsActive(possibleItemsPerPage[listStyle][index])
            ? 'active'
            : ''
        "
      >
        {{ possibleItemsPerPage[listStyle][index] }}
      </v-btn>
    </div>
  </v-row>
</template>

<script>
export default {
  props: {
    page: Number,
    numberOfPages: Number,
    possibleItemsPerPage: Array,
    itemsPerPage: Number,
    listStyle: Number,
    itemsTotal: Number,
    perPageLabel: {
      type: String,
      default: ""
    }
  },
  computed: {
    pageProp: {
      get: function () {
        return this.page;
      },
      set: function (newValue) {
        this.$emit("update:page", newValue);
      },
    },
  },
  methods: {
    updateItemsPerPage: function (target) {
      if (target === "all") {
        target = 99;
      }
      this.$emit("update:itemsPerPage", target);
    },
    pageNumberIsActive: function (target) {
      if (target === "all") {
        target = 99;
      }
      return this.itemsPerPage === target;
    },
  },
};
</script>

<style src="./DataIteratorFooter.scss" lang="scss" scoped />
